import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	Upload
} from 'element-ui';

export default {
	name: 'simulator-business',
	computed: {
		...mapGetters({
			lead: 'getLead',
		})
	},
	data() {
		return {
			form: {
				leadId: '',
				studentsQuantity: 0,
				plan: '',
				companyName: '',
				name: '',
				contactName: '',
				contactEmailAddress: '',
				document: '',
				contactPhoneNumber: '',
				contactDocument: '',
				mobilePhoneNumber: '',
				fullAddress: '',
				zipcode: '',
				city: '',
				neighborhood: '',
				state: '',
				country: '',
				logo: '',
				termsOfServiceAgreement: ''
			}
		};
	},
	components: {
		Upload
	},
	methods: {
		...mapActions([
			'sendForm',
			'updateLead'
		]),
		send() {
			this.$validator.validateAll().then((valid) => {
				if (valid) {
					this.sendForm(this.form).then(() => {
						alert(this.$gettext('Formulário enviado com sucesso!'));
					}).catch((error) => {
						alert(error.response.data.statusDescription);
					});
				}
			});
		},
		update() {

			this.updateLead({
				id: this.lead.id,
				schoolName: this.lead.schoolName,
				contactName: this.lead.contactName,
				contactEmailAddress: this.lead.contactEmailAddress,
				mobilePhoneNumber: this.lead.mobilePhoneNumber,
				studentsQuantity: this.form.studentsQuantity,
				plan: this.form.plan,
				levels: this.lead.levels,
				voucherNumber: this.lead.voucherNumber
			}).then(() => {

			}).catch((error) => {
				alert(error.response.data.statusDescription);
			});
		}
	},
	created() {
		this.form.leadId = this.lead.id;
		this.form.studentsQuantity = this.lead.studentsQuantity;
		this.form.plan = this.lead.plan;
		this.form.name = this.lead.schoolName;
		this.form.contactName = this.lead.contactName;
		this.form.contactEmailAddress = this.lead.contactEmailAddress;
		this.form.mobilePhoneNumber = this.lead.mobilePhoneNumber;
	}

};



// WEBPACK FOOTER //
// ./sources/app/simulator/simulator/values/index.js